import { render } from "./ReceiptRewardForce.vue?vue&type=template&id=191b4b24&scoped=true"
import script from "./ReceiptRewardForce.vue?vue&type=script&lang=js"
export * from "./ReceiptRewardForce.vue?vue&type=script&lang=js"

import "./ReceiptRewardForce.vue?vue&type=style&index=0&id=191b4b24&scoped=true&lang=css"

import exportComponent from "E:\\workBase\\Vue\\hans-amdin-mobiles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191b4b24"]])

export default __exports__